export const MealsFormFamily = {
  title: 'Meals',
  formVersion: 1,
  description: 'Client Meals Intake Form',
  formKey: 'CLIENT_MEALS_INTAKE_FORM',
  questions: {
    'Meals-help': {
      questionId: 'Meals-help',
      fieldType: 'checkbox',
      rank: 1,
      questionData: {
        label: 'What kind of help do they need with meals?',
        helpText: '',
        required: true,
      },
      options: [
        {value: 'full-prep', label: 'Full meal preparation', isOther: false},
        {value: 'light-prep', label: 'Light meal prep (simple meals, reheating)', isOther: false},
        {value: 'setting-up', label: 'Setting up meals', isOther: false},
        {value: 'feeding', label: 'Feeding support', isOther: false},
        {value: 'encouragement', label: 'Encouragement or reminders to eat', isOther: false},
        {value: 'snacks', label: 'Preparing snacks throughout the day', isOther: false},
        {value: 'other', label: 'Other', isOther: true},
      ],
    },
    'Meals-dietary': {
      questionId: 'Meals-dietary',
      fieldType: 'checkbox',
      rank: 2,
      questionData: {
        label: 'What dietary needs or restrictions should the caregiver support?',
        helpText: '',
        required: true,
      },
      options: [
        {value: 'low-sodium', label: 'Low-sodium', isOther: false},
        {value: 'diabetic', label: 'Diabetic-friendly', isOther: false},
        {value: 'soft-pureed', label: 'Soft / pureed foods', isOther: false},
        {value: 'allergies', label: 'Allergies (dairy, gluten, nuts, etc.)', isOther: false},
        {value: 'high-calorie', label: 'High-calorie / weight-gain support', isOther: false},
        {value: 'heart-healthy', label: 'Heart-healthy diet', isOther: false},
        {value: 'no-requirements', label: 'No specific requirements', isOther: false},
        {value: 'other', label: 'Other', isOther: true},
      ],
    },
    'Meals-related-tasks': {
      questionId: 'Meals-related-tasks',
      fieldType: 'checkbox',
      rank: 3,
      questionData: {
        label: 'Do they need help with related tasks?',
        helpText: '',
        required: true,
      },
      options: [
        {value: 'grocery-shopping', label: 'Grocery shopping', isOther: false},
        {value: 'planning', label: 'Planning meals', isOther: false},
        {value: 'hydration', label: 'Tracking hydration', isOther: false},
        {value: 'cleanup', label: 'Cleaning up after meals', isOther: false},
        {value: 'labeling', label: 'Labeling and storing food safely', isOther: false},
        {value: 'other', label: 'Other', isOther: true},
      ],
    },
  },
};
